import React, { useContext, useState } from 'react';
import './SingleItemSelect.scss';
import { layoutContext } from '../FlashSustainabilityCalculator';
import { Button, Tooltip } from 'carbon-components-react';

export interface singleItemSelectProps {
  contents: any;
}

const SingleItemSelect = (singleItemSelectProps: singleItemSelectProps) => {
  const { contents } = singleItemSelectProps;
  const { selectedOption, setSelectedOption } = useContext(layoutContext);
  const [selectedAmount, setSelectedAmount] = useState(50);
  const [selectedPerformance, setSelectedPerformance] = useState('medium');
  const cssMainClass = 'flash-sustainability-calculator_single-select';
  const usableStMax = 1000;

  const selectedOptionHandler = (usableSt: number, performanceLev: string) => {
    if (setSelectedOption) {
      setSelectedOption({
        usableStorage: usableSt,
        performanceLevel: performanceLev,
      });
    }
  };

  return (
    <div className={`${cssMainClass} bx--row`}>
      <p className={`${cssMainClass}_label bx--col-sm-4 bx--col-lg-3`}>
        {contents.label}
        <Tooltip className={`${cssMainClass}_label-tooltip`} direction="bottom">
          <p>{contents.tooltip}</p>
        </Tooltip>
      </p>
      <div className={`${cssMainClass}_options-wrapper bx--row`}>
        {contents.amountValue
          ? contents.amountValue.map((option: number, i: number) => {
              const isSelected =
                selectedAmount === option ? 'primary' : 'secondary';

              const isDisabled =
                selectedOption?.performanceLevel === 'lite' &&
                option === usableStMax;

              const perfLevel = selectedOption?.performanceLevel
                ? selectedOption?.performanceLevel
                : 'medium';

              return (
                <Button
                  className={`${cssMainClass}_options ${cssMainClass}_options_usable-storage`}
                  disabled={isDisabled}
                  kind={isSelected}
                  key={i}
                  onClick={() => {
                    setSelectedAmount(option);
                    selectedOptionHandler(option, perfLevel);
                  }}
                >
                  <p className={`${cssMainClass}_options-label`}>{option} TB</p>
                </Button>
              );
            })
          : contents.performanceValue.map((option: any, i: number) => {
              const initialDefaultValue = 50;
              const isSelected =
                selectedPerformance === option.range ? 'primary' : 'secondary';
              const isDisabled =
                selectedOption?.usableStorage === usableStMax &&
                option.range === 'lite';
              const usableSt = selectedOption?.usableStorage
                ? selectedOption?.usableStorage
                : initialDefaultValue;
              return (
                <Button
                  className={`${cssMainClass}_options ${cssMainClass}_options_performance-level`}
                  disabled={isDisabled}
                  key={i}
                  kind={isSelected}
                  onClick={() => {
                    setSelectedPerformance(option.range);
                    selectedOptionHandler(usableSt, option.range);
                  }}
                >
                  <p className={`${cssMainClass}_options-label`}>
                    {option.label}
                  </p>
                  <p className={`${cssMainClass}_options-label`}>
                    {option.performanceRange}
                  </p>
                </Button>
              );
            })}
      </div>
    </div>
  );
};

export default SingleItemSelect;
